import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { ApprovalEvent } from './ApprovalEvent.entity';
import { Mention } from './Mention.entity';
import { SaveSendMailJob } from './SaveSendMailJob.entity';
import { TimeTrackingStopwatch } from './TimeTrackingStopwatch.entity';

export type NotificationUnion<T extends EMode = EMode.entity> =
  T extends EMode.entity
    ?
        | Mention<T>
        | SaveSendMailJob<T>
        | ApprovalEvent<T>
        | TimeTrackingStopwatch<T>
    : {
        /** Alias: Mention */
        mention?: Mention<T>;
        /** Alias: SaveSendMailJob */
        saveSendMailJob?: SaveSendMailJob<T>;
        /** Alias: ApprovalEvent */
        approvalEvent?: ApprovalEvent<T>;
        /** Alias: TimeTrackingStopwatch */
        timeTrackingStopwatch?: TimeTrackingStopwatch<T>;
      };

const fields: FieldDefinitions<NotificationUnion<EMode.query>> = {
  mention: {
    alias: 'mention',
    entity: Entities.mention,
  },
  saveSendMailJob: {
    alias: 'saveSendMailJob',
    entity: Entities.saveSendMailJob,
  },
  approvalEvent: {
    alias: 'approvalEvent',
    entity: Entities.approvalEvent,
  },
  timeTrackingStopwatch: {
    alias: 'timeTrackingStopwatch',
    entity: Entities.timeTrackingStopwatch,
  },
};

export const notificationUnionEntityDefinition: EntitiyDefinition<
  NotificationUnion<EMode.query>
> = {
  kind: 'union',
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'NotificationUnion',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
